import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import filter from "lodash/filter";
import { filterOutNodesThatAreNotVisible } from "../../components/NodeChildrenRenderer";
import { getNodesThatCanBeRendered } from "../../utils/getNodesThatCanBeRendered";
export var getAllVisibleNodes = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var tree, nodesConditionalVisibility, allVisibilityPromises, nodeId, node, visibilityPromises;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tree = context.tree;
          nodesConditionalVisibility = {};
          allVisibilityPromises = [];
          for (nodeId in tree) {
            node = tree[nodeId];
            if (node.children && nodesConditionalVisibility[node.id] !== false) {
              visibilityPromises = getNodesThatCanBeRendered(tree, node.children).filter(function (node) {
                return isNotUndefined(node.isNodeVisible);
              }).map(function (node) {
                return node.isNodeVisible(context).then(function (isVisible) {
                  nodesConditionalVisibility = updateNodeVisibility(tree, node, isVisible, nodesConditionalVisibility);
                  return isVisible;
                });
              });
              allVisibilityPromises = [].concat(_toConsumableArray(allVisibilityPromises), _toConsumableArray(visibilityPromises));
            }
          }
          return _context.abrupt("return", Promise.all(allVisibilityPromises).then(function () {
            return filter(tree, function (node) {
              return filterOutNodesThatAreNotVisible(node, nodesConditionalVisibility);
            });
          }));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAllVisibleNodes(_x) {
    return _ref.apply(this, arguments);
  };
}();
// @ts-prune-ignore-next
export var updateNodeVisibility = function updateNodeVisibility(tree, node, isVisible, nodeVisibility) {
  if (!node) {
    return nodeVisibility;
  }
  if (!isVisible) {
    nodeVisibility = _objectSpread(_objectSpread({}, nodeVisibility), {}, _defineProperty({}, node.id, false));
    if (node.children) {
      var _iterator = _createForOfIteratorHelper(node.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var childrenNodeId = _step.value;
          nodeVisibility = _objectSpread(_objectSpread({}, nodeVisibility), {}, _defineProperty({}, childrenNodeId, false));
          nodeVisibility = updateNodeVisibility(tree, tree[childrenNodeId], false, nodeVisibility);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      return _objectSpread(_objectSpread({}, nodeVisibility), {}, _defineProperty({}, node.id, false));
    }
  }
  return _objectSpread(_objectSpread({}, nodeVisibility), {}, _defineProperty({}, node.id, isVisible));
};